import axios from "axios";

export type HttpErrorKind =
  | "cancelled"
  | "timeout"
  | "network"
  | "unauthorized"
  | "validation"
  | "server"
  | "client"
  | "unknown";

export function classifyHttpError(error: unknown): HttpErrorKind {
  if (!axios.isAxiosError(error)) return "unknown";
  if (error.code === "ERR_CANCELED") return "cancelled";
  if (error.code === "ECONNABORTED" || error.code === "ETIMEDOUT") return "timeout";
  const status = error.response?.status;
  if (!status) return "network";
  if (status === 401) return "unauthorized";
  if (status === 400 || status === 422) return "validation";
  if (status >= 500) return "server";
  return "client";
}
